import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import DualListBox from "../duallistBox";
import Cookies from "js-cookie";
import { useUserPermissions } from "../UserPermissionsContext";
import { DatePicker, Spin } from "antd";
import { Toast } from "react-bootstrap";
import CommonSelect from "../../core/common/commonSelect";
import dayjs from "dayjs";
type User = {
  work_name?: string | null;
  phone_number?: string | null;
  states?: Array<number>;
  zones?: Array<number>;
  branches?: Array<number>;
  is_idealtime?: boolean;
  service_division?: number;
  agents?: Array<number>;
  building_category?: Array<number>;
  designations?: Array<number>;
  departments?: Array<number>;
  start_date?: string;
  end_date?: string;
  is_current_work?: boolean;
  is_employee_selection?: boolean;
};

interface State {
  id: number;
  name: string;
}

interface Zone {
  id: number;
  name: string;
}

interface Branch {
  id: number;
  name: string;
}

interface ServiceDivision {
  id: number;
  name: string;

}

interface BuildingCategory {
  id: number;
  name: string;
}

export type Option = {
  value: string;
  label: string;
};

interface ErrorMessages {
  category_name?: string[];
}

interface Agents {
  id: number;
  username: string;
}

interface Department {
  department_id: number;
  name: string;
}
interface Designation {
  designation_id: number;
  name: string;
}

interface Employees {
  teacher_id: number;
  full_name: string;
}

const AddEmployeeWorkAssignment = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};
  const jwtToken = Cookies.get("authToken");
  const { webApi, userPermissions } = useUserPermissions();
  const [profileRecord, setProfileRecord] = useState<User>("" as User);
  const [chosenStates, setChosenStates] = useState<number[]>([]);
  const [chosenServiceDivisions, setChosenServiceDivisions] = useState<number[]>([]);
  const [chosenZones, setChosenZones] = useState<number[]>([]);
  const [chosenBranches, setChosenBranches] = useState<number[]>([]);
  const [chosenAgents, setChosenAgents] = useState<number[]>([]);
  const [chosenDepartments, setChosenDepartments] = useState<number[]>([]);
  const [chosenDesignations, setChosenDesignations] = useState<number[]>([]);
  const [chosenEmployees, setChosenEmployees] = useState<number[]>([]);
  const [states, setStates] = useState<State[]>([]);
  const [zones, setZones] = useState<Zone[]>([]);
  const [branches, setBranches] = useState<Branch[]>([]);
  const [agents, setAgents] = useState<Agents[]>([]);
  const [departments, setDepartments] = useState<Department[]>([]);
  const [designations, setDesignations] = useState<Designation[]>([]);
  const [employees, setEmployees] = useState<Employees[]>([]);
  const [serviceDivisions, setServiceDivisions] = useState<ServiceDivision[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [idealTime, setIdealTime] = useState(true);
  const [toastMessage, setToastMessage] = useState("");
  const [buildingCategories, setBuildingCategories] = useState<BuildingCategory[]>([]);
  const [chosenBuildingCategories, setChosenBuildingCategories] = useState<number[]>([]);
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);
  const [selectedServiceDivision, setSelectedServiceDivision] = useState<Option | null>(null
  );
  const [errorMessage, setErrorMessage] = useState<ErrorMessages>({});
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
  const day = String(today.getDate()).padStart(2, "0");
  const formattedDate = `${month}-${day}-${year}`;
  const defaultValue = dayjs(formattedDate);
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchBuildingCategories = async () => {
    const response = await fetch(
      `${webApi}/emp_work_assignment/building_category_dropdown_for_emp_work_assign/`,
      options
    );
    const data = await response.json();

    // Map API response to only id and name
    const formatted = data.map((item: { building_category_id: any; name: any; }) => ({
      id: item.building_category_id,
      name: item.name
    }));

    setBuildingCategories(formatted);
  };

  const fetchAgents = async () => {
    const response = await fetch(
      `${webApi}/emp_work_assignment/emp_team_members_dropdown_for_emp_work_assign/`, options);
    const data = await response.json();
    setAgents(data);
  };

  const fetchDepartmments = async () => {
    const response = await fetch(
      `${webApi}/emp_work_assignment/department_dropdown_for_emp_work_assign/?service_division_id=${selectedServiceDivision?.value}`, options);
    const data = await response.json();
    setDepartments(data);
  };

  const fetchDesignations = async () => {
    const response = await fetch(
      `${webApi}/emp_work_assignment/designation_dropdown_for_emp_work_assign/?service_division_id=${selectedServiceDivision?.value}`, options);
    const data = await response.json();
    setDesignations(data);
  };

  useEffect(() => {
    if (selectedServiceDivision?.value) {
      fetchDepartmments();
      fetchDesignations();
    }
  }, [selectedServiceDivision]);

  const fetchStateData = async () => {
    const response = await fetch(
      `${webApi}/emp_work_assignment/state_drop_down_for_emp_work_assign/${chosenBuildingCategories}/`,
      options
    );
    return await response.json();
  };

  const fetchServiceDivisions = async () => {
    const response = await fetch(
      `${webApi}/emp_work_assignment/service_division_dropdown_based_on_user_for_emp_work_assign/`,
      options
    );
    const data = await response.json();
    setServiceDivisions(data);
  };

  const fetchZonesData = async () => {
    const response = await fetch(
      `${webApi}/emp_work_assignment/zones_drop_down_for_emp_work_assign/${chosenStates}/`,
      options
    );
    return await response.json();
  };

  const fetchBranchesData = async () => {
    const response = await fetch(
      `${webApi}/emp_work_assignment/branches_drop_down_for_emp_work_assign/${chosenZones}/`,
      options
    );
    return await response.json();
  };

  const fetchEmployees = async () => {
    const response = await fetch(
      `${webApi}/emp_work_assignment/employee_dropdown_for_emp_work_assign/?branch_ids=${chosenBranches.join(',')}&designation_ids=${chosenDesignations.join(',')}&department_ids=${chosenDepartments.join(',')}`,
      options
    );
    return await response.json();
  };

  // const fetchUserProfileData = async () => {
  //   const response = await fetch(`${webApi}/user/add_update_userprofile/${id}/`, options);
  //   return await response.json();
  // };

  // const fetchData = async () => {
  //   setIsLoading(true);
  //   try {
  //     const [profileData] = await Promise.all([
  //       // fetchStateData(),
  //       fetchUserProfileData(),
  //     ]);

  //     // const states = stateData.results.map(
  //     //   (state: { state_id: number; name: string; is_active: boolean }) => ({
  //     //     id: state.state_id,
  //     //     name: state.name,
  //     //   })
  //     // );
  //     setStates(states);
  //     setProfileRecord(profileData);
  //     setChosenBuildingCategories(profileData.building_category || []);
  //     setChosenStates(profileData.states || []);
  //     setChosenZones(profileData.zones || []);
  //     setChosenBranches(profileData.branches || []);
  //     setChosenServiceDivisions(profileData.service_divisions || [])
  //     setIdealTime(profileData.is_idealtime);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  useEffect(() => {
    if (!checkPermission("add_empworkassignment", "empworkassignment")) {
      navigate(routes.adminDashboard);
    } else {
      // fetchData();
      fetchServiceDivisions()
      fetchBuildingCategories();
      fetchStateData();
      fetchAgents();
    }
  }, [userPermissions]);

  useEffect(() => {
    const fetchStates = async () => {
      if (chosenBuildingCategories.length > 0) {
        const statesData1 = await fetchStateData();
        const statesData = statesData1;
        const states = statesData.results.map((zone: any) => ({
          id: zone.state_id,
          name: zone.name,
        }));
        setStates(states);
      } else {
        // Clear zones and branches if no states are selected
        setStates([]);
        setChosenStates([]);
        setZones([]);
        setChosenZones([]);
        setBranches([]);
        setChosenBranches([]);
      }
    };
    fetchStates();
  }, [chosenBuildingCategories]);

  useEffect(() => {
    const fetchZones = async () => {
      if (chosenStates.length > 0) {
        const zonesData1 = await fetchZonesData();
        const zonesData = zonesData1.results;
        const zones = zonesData.map((zone: any) => ({
          id: zone.zone_id,
          name: zone.name,
        }));
        setZones(zones);
        const validZoneIds = chosenZones.filter(id =>
          zones.some((zone: { id: any; }) => zone.id === id)
        );
        setChosenZones(validZoneIds);
      } else {
        // Clear zones and branches if no states are selected
        setZones([]);
        setChosenZones([]);
        setBranches([]);
        setChosenBranches([]);
      }
    };
    fetchZones();
  }, [chosenStates]);

  useEffect(() => {
    const fetchBranches = async () => {
      if (chosenZones.length > 0) {
        const branchesData1 = await fetchBranchesData();
        const branchesData = branchesData1.results;
        const branches = branchesData.map((branch: any) => ({
          id: branch.branch_id,
          name: branch.name,
        }));
        setBranches(branches);
        const validBranchIds = chosenBranches.filter(id =>
          branches.some((zone: { id: any; }) => zone.id === id)
        );
        setChosenBranches(validBranchIds);
      } else {
        // Clear branches if no zones are selected
        setBranches([]);
        setChosenBranches([]);
      }
    };
    fetchBranches();
  }, [chosenZones]);

  useEffect(() => {
    const getEmployees = async () => {
      if (chosenBranches.length > 0) {
        try {
          const response = await fetchEmployees();




          const employeeOptions = response.map((employee: any) => ({
            id: employee.teacher_id,
            name: employee.full_name,
          }));

          setEmployees(response);

          // Keep only valid selected employees
          const validEmployeeIds = chosenEmployees.filter((id) =>
            employeeOptions.some((employee: any) => employee.id === id)
          );

          setChosenEmployees(validEmployeeIds);
        } catch (error) {
          console.error("Error fetching employees:", error);
          setEmployees([]);
        }
      } else {
        setEmployees([]);
        setChosenEmployees([]);
      }
    };

    getEmployees();
  }, [chosenBranches, chosenDepartments, chosenDesignations]);




  const handleProfileSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    setIsLoading1(true);
    e.preventDefault();

    const updatedProfileRecord = {
      ...profileRecord,
      states: chosenStates,
      zones: chosenZones,
      branches: chosenBranches,
      service_division: selectedServiceDivision?.value,
      building_category: chosenBuildingCategories,
      designations: chosenDesignations,
      departments: chosenDepartments,
      agents: chosenAgents,
      selected_employees: chosenEmployees,
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(updatedProfileRecord),
    };

    try {
      const url = `${webApi}/emp_work_assignment/employee_work_assignment/`;
      const response = await fetch(url, requestOptions);

      if (!response.ok) {
        const errorData = await response.json();
        setToastMessage(errorData.phone_number);
        setShowSolidDangerToast(true);
        throw new Error(errorData.detail || "Failed to update profile");
      }

      const data = await response.json();
      console.log("Profile updated successfully:", data);
      navigate(routes.employeeWorkAssignment);
    } catch (error) {
      console.error("Error updating profile:", error);
    } finally {
      setIsLoading1(false);
    }
  };

  const availableStates = states.filter(
    (state) => !chosenStates.includes(state.id)
  );
  const availableZones = zones.filter((zone) => !chosenZones.includes(zone.id));
  const availableBranches = branches.filter(
    (branch) => !chosenBranches.includes(branch.id)
  );

  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setProfileRecord({ ...profileRecord, [name]: value === "true" });
  };

  const serviceDivisionOptions = serviceDivisions.map(serviceDivision => ({
    value: String(serviceDivision.id),
    label: serviceDivision.name
  }));

  const agentOptions = agents.map(agent => ({
    id: Number(agent.id),
    name: agent.username
  }));

  const departmentOptions = departments.map(department => ({
    id: Number(department.department_id),
    name: department.name
  }));

  const designationOptions = designations.map(designation => ({
    id: Number(designation.designation_id),
    name: designation.name
  }));

  const employeesOptions = employees.map(employee => ({
    id: Number(employee.teacher_id),
    name: employee.full_name
  }));

  const handleServiceDivisionChange = async (selected: Option | null) => {
    const serviceDivision = serviceDivisions.find(
      (c) => c.id === parseInt(selected?.value || "")
    );

    // Update state
    setSelectedServiceDivision(
      serviceDivision
        ? {
          value: serviceDivision.id.toString(),
          label: serviceDivision.name,
        }
        : null
    );
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setProfileRecord({ ...profileRecord, work_name: e.target.value });
  };

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };

  const handleStartDateChange = (date: dayjs.Dayjs | null) => {
    if (date) {
      const formattedDate = date.format('YYYY-MM-DD'); // Format as "YYYY-MM-DD"
      setProfileRecord(prev => ({
        ...prev,
        start_date: formattedDate
      }));
    } else {
      setProfileRecord(prev => ({
        ...prev,
        start_date: undefined
      }));
    }
  };


  const handleEndDateChange = (date: dayjs.Dayjs | null) => {
    if (date) {
      const formattedDate = date.format('YYYY-MM-DD'); // Format as "YYYY-MM-DD"
      setProfileRecord(prev => ({
        ...prev,
        end_date: formattedDate
      }));
      // if (errors['end_date']) {
      //   setErrors((prev: any) => ({ ...prev, end_date: null }));
      // }
    } else {
      setProfileRecord(prev => ({
        ...prev,
        end_date: undefined
      }));
    }
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Add Work Assignment</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.employeeDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.employeeWorkAssignment}>Work Assignment</Link>
                  </li>
                  <li className="breadcrumb-item active">Add Work Assignment</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              <div
                className="card"
                style={{
                  width: "70%",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  borderRadius: "15px",
                }}
              >
                {isLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      height: "100vh",
                      paddingTop: "20px",
                    }}
                  >
                    <Spin /> {/* Display loader while loading */}
                  </div>
                ) : (
                  <div className="card-body">
                    <form onSubmit={handleProfileSubmit}>
                      <div className="modal-body light-violet-bg">
                        <div className="row">

                          {/* Work Name */}
                          <div className="col-lg-6 col-12">
                            <div className="form-group mb-3">
                              <label className="form-label">Work Name</label>

                              <input
                                type="text"
                                className={`form-control ${errorMessage.category_name ? "is-invalid" : ""
                                  }`}
                                placeholder="Work Name"
                                onChange={handleInputChange}
                                value={profileRecord.work_name || ""}
                                required
                              />
                            </div>
                          </div>

                          {/* Service Division */}
                          <div className="col-lg-6 col-12">
                            <div className="form-group mb-3">
                              <label className="form-label">Service Division</label>

                              <CommonSelect
                                className="select"
                                options={serviceDivisionOptions}
                                onChange={handleServiceDivisionChange}
                                value={selectedServiceDivision}
                                isRequired
                              />
                            </div>
                          </div>

                          {/* Start Date */}
                          <div className="col-lg-6 col-12">
                            <div className="mb-3">
                              <label className="form-label">
                                Start Date <span style={{ color: "red" }}>*</span>
                              </label>

                              <div className="date-pic">
                                <DatePicker
                                  className="form-control datetimepicker"
                                  format={{
                                    format: "DD-MM-YYYY",
                                    type: "mask",
                                  }}
                                  getPopupContainer={getModalContainer}
                                  defaultValue={defaultValue}
                                  value={
                                    profileRecord.start_date
                                      ? dayjs(profileRecord.start_date)
                                      : null
                                  }
                                  onChange={handleStartDateChange}
                                  placeholder="Choose Start date"
                                />
                              </div>
                            </div>
                          </div>

                          {/* End Date */}
                          <div className="col-lg-6 col-12">
                            <div className="mb-3">
                              <label className="form-label">
                                End Date <span style={{ color: "red" }}>*</span>
                              </label>

                              <div className="date-pic">
                                <DatePicker
                                  className="form-control datetimepicker"
                                  format={{
                                    format: "DD-MM-YYYY",
                                    type: "mask",
                                  }}
                                  getPopupContainer={getModalContainer}
                                  defaultValue={defaultValue}
                                  value={
                                    profileRecord.end_date
                                      ? dayjs(profileRecord.end_date)
                                      : null
                                  }
                                  onChange={handleEndDateChange}
                                  placeholder="Choose End date"
                                />
                              </div>
                            </div>
                          </div>

                          {/* Is Current Work */}
                          <div className="col-lg-6 col-12">
                            <div className="radio-group-item p-2">
                              <label className="form-label">
                                Is Current Work{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>

                              <div>
                                <input
                                  type="radio"
                                  id="is_current_work_yes"
                                  name="is_current_work"
                                  value="true"
                                  checked={profileRecord.is_current_work === true}
                                  onChange={handleRadioChange}
                                  required
                                />

                                <label
                                  htmlFor="is_current_work_yes"
                                  className="ms-1 me-3"
                                >
                                  Yes
                                </label>

                                <input
                                  type="radio"
                                  id="is_current_work_no"
                                  name="is_current_work"
                                  value="false"
                                  checked={profileRecord.is_current_work === false}
                                  onChange={handleRadioChange}
                                />

                                <label
                                  htmlFor="is_current_work_no"
                                  className="ms-1"
                                >
                                  No
                                </label>
                              </div>
                            </div>
                          </div>

                          {/* Is Employee Selection */}


                          {/* Agents */}
                          <div className="col-12">
                            <div className="form-group dual-list-box-container">
                              <label className="form-label">Agents</label>

                              <DualListBox
                                options={agentOptions}
                                selected={chosenAgents
                                  .map((id) =>
                                    agentOptions.find((state) => state.id === id)
                                  )
                                  .filter(
                                    (state): state is State =>
                                      state !== undefined
                                  )}
                                onChange={(selected) => {
                                  const selectedIds = selected.map(
                                    (state) => state.id
                                  );
                                  setChosenAgents(selectedIds);
                                }}
                              />
                            </div>
                          </div>

                          {/* Building Category */}
                          <div className="col-12">
                            <div className="form-group dual-list-box-container">
                              <label className="form-label">
                                Building Category
                              </label>

                              <DualListBox
                                options={buildingCategories}
                                selected={chosenBuildingCategories
                                  .map((id) =>
                                    buildingCategories.find(
                                      (state) => state.id === id
                                    )
                                  )
                                  .filter(
                                    (state): state is State =>
                                      state !== undefined
                                  )}
                                onChange={(selected) => {
                                  const selectedIds = selected.map(
                                    (state) => state.id
                                  );
                                  setChosenBuildingCategories(selectedIds);
                                }}
                              />
                            </div>
                          </div>

                          {/* States */}
                          <div className="col-12">
                            <div className="form-group dual-list-box-container">
                              <label className="form-label">States</label>

                              <DualListBox
                                options={availableStates}
                                selected={chosenStates
                                  .map((id) =>
                                    states.find((state) => state.id === id)
                                  )
                                  .filter(
                                    (state): state is State =>
                                      state !== undefined
                                  )}
                                onChange={(selected) => {
                                  const selectedIds = selected.map(
                                    (state) => state.id
                                  );
                                  setChosenStates(selectedIds);
                                }}
                              />
                            </div>
                          </div>

                          {/* Zones */}
                          <div className="col-12">
                            <div className="form-group dual-list-box-container">
                              <label className="form-label">Zones</label>

                              <DualListBox
                                options={availableZones}
                                selected={chosenZones
                                  .map((id) =>
                                    zones.find((zone) => zone.id === id)
                                  )
                                  .filter(
                                    (zone): zone is Zone =>
                                      zone !== undefined
                                  )}
                                onChange={(selected) => {
                                  const selectedIds = selected.map(
                                    (zone) => zone.id
                                  );
                                  setChosenZones(selectedIds);
                                }}
                              />
                            </div>
                          </div>

                          {/* Branches */}
                          <div className="col-12">
                            <div className="form-group dual-list-box-container">
                              <label className="form-label">Branches</label>

                              <DualListBox
                                options={availableBranches}
                                selected={chosenBranches
                                  .map((id) =>
                                    branches.find(
                                      (branch) => branch.id === id
                                    )
                                  )
                                  .filter(
                                    (branch): branch is Branch =>
                                      branch !== undefined
                                  )}
                                onChange={(selected) => {
                                  const selectedIds = selected.map(
                                    (branch) => branch.id
                                  );
                                  setChosenBranches(selectedIds);
                                }}
                              />
                            </div>
                          </div>

                          {/* Departments */}
                          <div className="col-12">
                            <div className="form-group dual-list-box-container">
                              <label className="form-label">
                                Departments
                              </label>

                              <DualListBox
                                options={departmentOptions}
                                selected={chosenDepartments
                                  .map((id) =>
                                    departmentOptions.find(
                                      (state) => state.id === id
                                    )
                                  )
                                  .filter(
                                    (state): state is State =>
                                      state !== undefined
                                  )}
                                onChange={(selected) => {
                                  const selectedIds = selected.map(
                                    (state) => state.id
                                  );
                                  setChosenDepartments(selectedIds);
                                }}
                              />
                            </div>
                          </div>

                          {/* Designations */}
                          <div className="col-12">
                            <div className="form-group dual-list-box-container">
                              <label className="form-label">
                                Designations
                              </label>

                              <DualListBox
                                options={designationOptions}
                                selected={chosenDesignations
                                  .map((id) =>
                                    designationOptions.find(
                                      (state) => state.id === id
                                    )
                                  )
                                  .filter(
                                    (state): state is State =>
                                      state !== undefined
                                  )}
                                onChange={(selected) => {
                                  const selectedIds = selected.map(
                                    (state) => state.id
                                  );
                                  setChosenDesignations(selectedIds);
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-12">
                            <div className="radio-group-item p-2">
                              <label className="form-label">
                                For Selected Employees{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>

                              <div>
                                <input
                                  type="radio"
                                  id="is_employee_selection_yes"
                                  name="is_employee_selection"
                                  value="true"
                                  checked={
                                    profileRecord.is_employee_selection === true
                                  }
                                  onChange={handleRadioChange}
                                  required
                                />

                                <label
                                  htmlFor="is_employee_selection_yes"
                                  className="ms-1 me-3"
                                >
                                  Yes
                                </label>

                                <input
                                  type="radio"
                                  id="is_employee_selection_no"
                                  name="is_employee_selection"
                                  value="false"
                                  checked={
                                    profileRecord.is_employee_selection === false
                                  }
                                  onChange={handleRadioChange}
                                />

                                <label
                                  htmlFor="is_employee_selection_no"
                                  className="ms-1"
                                >
                                  No
                                </label>
                              </div>
                            </div>
                          </div>
                          {profileRecord.is_employee_selection && (
                            <div className="col-12">
                              <div className="form-group dual-list-box-container">
                                <label className="form-label">Employees</label>

                                <DualListBox
                                  options={employeesOptions}
                                  selected={chosenEmployees
                                    .map((id) =>
                                      employeesOptions.find(
                                        (state) => state.id === id
                                      )
                                    )
                                    .filter(
                                      (employee): employee is State =>
                                        employee !== undefined
                                    )}
                                  onChange={(selected) => {
                                    const selectedIds = selected.map(
                                      (state) => state.id
                                    );
                                    setChosenEmployees(selectedIds);
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="modal-footer">
                        <Link
                          className="btn btn-primary"
                          to={routes.employeeWorkAssignment}
                          style={{
                            backgroundColor: "lightcoral",
                            color: "white",
                            marginRight: "5px",
                          }}
                        >
                          Cancel
                        </Link>

                        <button
                          className="btn btn-primary"
                          type="submit"
                          disabled={isLoading}
                        >
                          {isLoading1 ? (
                            <i className="spinner-border spinner-border-sm"></i>
                          ) : (
                            <>Save</>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                )}
                <Toast
                  show={showSolidDangerToast}
                  onClose={handleSolidDangerToastClose}
                  id="solidDangerToast"
                  className="colored-toast bg-danger text-fixed-white"
                  role="alert"
                  aria-live="assertive"
                  aria-atomic="true"
                  style={{
                    position: "fixed",
                    top: "20px",
                    right: "20px",
                    zIndex: 1050,
                  }}
                >
                  <Toast.Body>{toastMessage}</Toast.Body>
                </Toast>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEmployeeWorkAssignment;
